import * as React from 'react';
import { useAuth } from 'hooks/auth';
import { applyQueryString, api } from 'services';
import type { Filters } from 'hooks/store/stock-balance';

type FetchStocksPayload = {
  filters?: Filters
}

export const useFetchStocks = () => {
  const { token } = useAuth();

  const fetchStocks = React.useCallback(async (payload?: FetchStocksPayload) => {

    const filters = payload?.filters || {};

    // removing empty values
    Object.entries(filters).forEach(([key, value]) => {
      if (!value || (Array.isArray(value) && !value?.length)) {
        delete (filters as Record<string, unknown>)[key];
      }
    });

    const url = applyQueryString(`/stocks`, {
      ...payload?.filters
    });

    const { data } = await api.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  }, [token]);

  return {
    fetchStocks
  }
};